function reducePlaylists(data) {
  const folderCodes = ['p', 'g']
  return {
    ...data,
    data: data?.data?.map((item) => {
      const firstChar = item.id.slice(0, 1)
      const droppable = folderCodes.includes(firstChar)
      return {
        ...item,
        droppable,
      }
    }),
  }
}

export default reducePlaylists
